import React from 'react';

import Line from '../../graph/line/Line';
import SentimentPie from '../../graph/pie/SentimentPie';

import './QuickResult.css';
import SentimentBar from '../../graph/bar/SentimentBar';
import CategoryMap from '../../graph/force-directed-tree/CategoryMap';
import ReactWordcloud from 'react-wordcloud';
import {select} from 'd3-selection';
import "d3-transition";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import SpinnerBox from '../../spinner-box/SpinnerBox';


// const QuickWordCloud = React.memo((props) => {
  const QuickWordCloud = (props) => {
    const options = {
      colors: [  "#6E37FA", "#32BBB9", "#FF9408", "#F40953", "#FA32A0", "#B30095", "#FFD500", "#AAF564", "#50E6AA", "#2765F0"    ],
      fontFamily: "impact",
      fontSizes: [15, 50],
      fontStyle: "normal",
      fontWeight: "normal",
      padding: 1,
      rotations: 3,
      rotationAngles: [0, 90],
      scale: "sqrt",
      spiral: "rectangular",
      transitionDuration: 1000,
      deterministic: false,
      tooltipOptions: {
        theme: 'light-border'
      },
      enableTooltip: true
    };
    const getCallback = (callback) => {
      return (word, event) => {
        const isActive = callback !== "onWordMouseOut";
        const element = event.target;
        const text = select(element);
        text
          // .on("click", () => {
          //   if (isActive) {
          //   }
          // })
          .transition()
          // .attr("background", "white")
          // .attr("font-size", isActive ? "300%" : "100%")
          .attr("text-decoration", isActive ? "underline" : "none");
      }
    }
    const callbacks = {
      // getWordColor: (word) => (word.value > 50 ? "orange" : "purple"),
      getWordTooltip: (word) =>`${word.text} (${word.value})`,
      // onWordClick: getCallback("onWordClick"),
      onWordMouseOut: getCallback("onWordMouseOut"),
      onWordMouseOver: getCallback("onWordMouseOver")
    }
    return(
      <>
      {
        props.data.loaded == false ?
        <SpinnerBox width={props.width} height={props.height}/>
        :<div style={{textAlign:"center"}}>
          <div style={{height: props.height,width: props.width, display:'inline-block'}}>
            <ReactWordcloud words={props.data.wordcloudData} options={options} callbacks={callbacks}/>
          </div>
        </div>
      }
      </>
    )      
  // },[props.data]);
  }

  // const QuickSentimentBar = React.memo((props) => {
  const QuickSentimentBar = (props) => {
    return(
      <>
      {
        props.data.loaded == false ?
        <SpinnerBox width={props.width} height={props.height}/>
        :<SentimentBar type='quick' width={props.width} height={props.height} data={props.data.sentimentBarData} />
      }
      </>
    )
  // }, [props.data]);
  }

  // const QuickPie = React.memo((props) => {
  const QuickPie = (props) => {
      return(
      <>
      {
        props.data.loaded == false ?
        <SpinnerBox width={props.width} height={props.height}/>
        :<SentimentPie type='quick' width={props.width} height={props.height} data={props.data.pieData} />
      }
      </>
    )
  // }, [props.data]);
  }
    
  // const QuickHorizontalBar = React.memo((props) => {
  //   return(
  //     <HorizontalBar width={props.width} height={props.height} data={props.data} />
  //     )
  // }, [props.data]);

  // const KeywordRelationMap = React.memo((props) => {
  //   return(
  //     <RelationMap width={props.width} height={props.height} data={props.data} />
  //   )
  // }, [props.data]);

  // const QuickCategoryMap = React.memo((props) => {
  const QuickCategoryMap = (props) => {
    return(
      <>
      {
        props.data.loaded == false ?
        <SpinnerBox width={props.width} height={props.height}/>
        :<CategoryMap width={props.width} height={props.height} data={props.data.categoryMapData} />
      }
      </>
    )
  // }, [props.data])
  }

  // const BuzzLineGraph = React.memo((props) => {
  const BuzzLineGraph = (props) => {
    return(
      <>
      {
        props.data.loaded == false ?
        <SpinnerBox width={props.width} height={props.height}/>
        :<Line width={props.width} height={props.height} data={props.data.lineData} />
      }
      </>
    )
  // }, [props.data]);
  }


const QuickResult = (props) => {
  

  return (
    <div className="row featured-main">
      <div className="graphTit"><span className="purple">TOPIC</span> SUMMARY</div>
      <div id="TpSummaryBox">
        <div className="TpSummary">
          <span className="TpSummaryData">{props.searchedBasicData.totalPost}</span> 전체 게시글 수
          <span className="line"></span>
          <span className="TpSummaryData">{props.searchedBasicData.dailyPost}</span>하루 평균 게시글 수
        </div>
      </div>
      <div className="graphTit"><span className="purple">검색 키워드</span> 버즈량</div>
      <div className="graphBox">
        <div className="graph">
          <BuzzLineGraph width="100%" height={500} data={props.searchedBasicData} />
        </div>
      </div>
      <table className="tablesty_Noline">
        <tr>
          <td width="50%" className="rightpadding">
            <div className="graphTit"><span className="purple">센티멘트</span> 분석</div>
            {/* <div className="graphBox2-blur"> */}
            <div className="graphBox2">
              <QuickSentimentBar width="100%" height={500} data={props.searchedSentiData} />
            </div>
          </td>
          <td width="50%" className="right">
            <div className="graphTit"><span className="purple">센티멘트</span> 분석</div>
            <div className="graphBox2">
              <QuickPie width="100%" height={500} data={props.searchedSentiData} />
            </div>
          </td>
        </tr>
      </table>
      <table className="tablesty_Noline">
        <tr>
          <td width="50%" className="rightpadding">
            <div className="graphTit"><span className="purple">연관어</span> 워드 클라우드</div>
            <div className="graphBox2">
              <QuickWordCloud width={500} height={500} data={props.searchedRelationData} />
            </div>
          </td>
          <td width="50%" className="right">
            <div className="graphTit"><span className="purple">카테고리</span> 분석</div>
            <div className="graphBox2">
              <QuickCategoryMap width="100%" height={500} data={props.searchedRelationData} />
            </div>
          </td>
        </tr>
      </table>
    </div>
  )
}

export default QuickResult;